export default {
  service: {
    title: "艾瑞爾網路股份有限公司用戶協議",
    content:
      "立契約書人\n消費者（以下簡稱「甲方」，請依會員註冊流程填寫）\n企業經營者名稱：艾瑞爾網路股份有限公司（以下簡稱「乙方」)\n代表人：蘇立家\n行政電話：02-2788-3611（1000-1800）\n營業所：台北市大安區忠孝東路4段166號10樓\n網址：https://www.facebook.com/AlongWithMyths/\n電子郵件：arielnetwork98@gmail.com\n統一編號：557370\n\n第一條、法定代理人\n\n甲方為限制行為能力人者，本契約訂定時，應經甲方之法定代理人同意，本契約始生效力；甲方為無行為能力人者，本契約之訂定，應由甲方之法定代理人代為之。\n若有限制行為能力人未經同意或無行為能力人未由法定代理人代為付費購買點數致生法定代理人主張退費時，法定代理人得依官網公告流程，備妥證明文件並提出申請，經乙方確認後，退還甲方未使用之遊戲費用。\n乙方應於官網首頁、遊戲登入頁面或購買頁面以中文明顯標示，若甲方為限制行為能力人或無行為能力人，除應符合上述規定外，並應於甲方之法定代理人閱讀、瞭解並同意本契約之所有內容後，方得使用本遊戲服務，本契約條款變更時亦同。\n\n第二條、契約適用之範圍\n\n乙方提供甲方網路連線遊戲服務及其他相關服務（以AA下簡稱本遊戲服務），甲乙雙方關於本遊戲服務之權利義務，依本契約條款之約定定之。\n\n第三條、契約之內容\n\n以下視為本契約之一部分，與本契約條款具有相同之效力：\n一、乙方有關本遊戲服務之廣告或宣傳內容。\n二、計費制遊戲之費率表及遊戲管理規則。\n本契約條款如有疑義時，應為甲方有利之解釋。\n\n第四條、名詞定義\n\n本契約之名詞定義如下：\n一、網路連線遊戲：係指甲方透過電腦、智慧型裝置或其他電子化載具，連結網際網路至乙方指定之伺服器所進行連線遊戲。但不包括電子遊戲場業管理條例所稱電子遊戲機、單純區域連線或其他無需透過網路連結遊戲伺服器之遊戲服務。\n二、遊戲網站：係指由乙方為提供本遊戲服務所建置之網站。\n三、遊戲管理規則：係指由乙方訂立，供為規範遊戲進行方式之規則且不影響雙方契約上之權利義務者。\n四、遊戲歷程：係指自甲方登入本遊戲起至登出本遊戲時止，電腦系統對甲方遊戲進行過程所為之紀錄。\n五、外掛程式：係指非由乙方提供，以影響或改變乙方網路連線遊戲運作為目的之程式。\n\n第五條、服務範圍\n\n本契約所提供之遊戲服務，係由乙方指定之伺服器，讓甲方透過網際網路連線登入使用本遊戲服務。但不包括甲方向網際網路接取服務業者申請接取網際網路之服務，及提供上網所需之各項硬體設備。\n\n第六條、遊戲登錄\n\n甲方申請使用本遊戲服務，應依申請流程，於遊戲內登錄所需之個人資料或其他必要資訊。\n為確保甲方使用本遊戲服務之權益，甲方提供之資料應可驗證身分，若有不正確或已變更時，應立即通知乙方更新。\n乙方若有為提供本遊戲服務與甲方聯絡之必要，而甲方未提供正確之個人資料或原提供之資料不符合真實且未更新，乙方得於甲方提供真實資料或更新資料前，暫停甲方遊戲進行及遊戲歷程查詢之服務。但甲方能證明其為契約當事人者，不在此限。\n\n第七條、契約解除權規定\n\n甲方得於開始遊戲後七日內，以書面告知乙方解除本契約，甲方無需說明理由及負擔任何費用。\n前項情形，甲方得就未使用之付費購買點數向乙方請求退費。\n\n第八條、計費方式\n\n本遊戲服務之收費計算方式為：\n免費制(遊戲程式內購)：\n本遊戲服務內（例如：遊戲商城、線上商店等）有提供需甲方額外付費購買之點數、商品或其他服務（例如：虛擬貨幣或寶物、進階道具等），乙方應在官網首頁、遊戲登入頁面或購買頁面公告載明付款方式及商品資訊。\n費率調整時，乙方應於預定調整生效日三十日前於官網首頁、遊戲登入頁面或購買頁面公告；若甲方於註冊帳號時已登錄通訊資料者，並依甲方登錄之通訊資料通知甲方。\n費率如有調整時，應自調整生效日起按新費率計收；若新費率高於舊費率時，甲方在新費率生效日前已於官網中登錄之付費購買點數或遊戲費用應依舊費率計收。\n\n第九條、本遊戲服務應載明之資訊\n\n乙方應於官網首頁、遊戲登入頁面或購買頁面及遊戲套件包裝上載明以下事項：\n一、依遊戲軟體分級管理辦法規定標示遊戲分級級別及禁止或適合使用之年齡層。\n二、進行本遊戲服務之最低軟硬體需求。\n三、有提供安全裝置者，其免費或付費資訊。\n四、有提供付費購買之機會中獎商品或活動，其活動內容、獎項及中獎等資訊，並應記載「此為機會中獎商品，消費者購買或參與活動不代表即可獲得特定商品」等提示。\n\n第十條、帳號與密碼之使用\n\n甲方完成註冊程序後取得之帳號及密碼，僅供甲方使用。\n前項之密碼得依乙方提供之修改機制進行變更。乙方人員（含客服人員、遊戲管理員）不得主動詢問甲方之密碼。\n乙方應於契約終止後三十日內，保留甲方之帳號及附隨於該帳號之電磁紀錄。\n契約非因可歸責甲方之事由而終止者，甲方於前項期間內辦理續用後，有權繼續使用帳號及附隨於該帳號之電磁紀錄。\n第二項期間屆滿時，甲方仍未辦理續用，乙方得刪除該帳號及附隨於該帳號之所有資料，但法令另有規定者不在此限。\n\n第十一條、帳號密碼遭非法使用之通知與處理\n\n當事人一方如發現帳號、密碼被非法使用時，應立即通知對方並由乙方進行查證，經乙方確認有前述情事後，得暫停該組帳號或密碼之使用權，更換帳號或密碼予甲方，立即限制第三人就本遊戲服務之使用權利，並將相關處理方式揭載於遊戲管理規則。\n乙方應於暫時限制遊戲使用權利之時起，以官網公告、推播、遊戲內信件或電子信箱通知前項第三人提出說明。\n如該第三人未於接獲通知時起七日內提出說明，乙方應直接回復遭不當移轉之電磁紀錄予甲方，如不能回復時可採其他雙方同意之相當補償方式，並於回復後解除對第三人之限制。\n但乙方有提供免費安全裝置（例如：防盜卡、電話鎖等）而甲方不使用或有其他可歸責於甲方之事由，乙方不負回復或補償責任。\n第一項之第三人不同意乙方前項之處理時，甲方得依報案程序，循司法途徑處理。\n乙方依第一項規定限制甲方或第三人之使用權時，在限制使用期間內，乙方不得向甲方或第三人收取費用。\n甲方如有申告不實之情形致生乙方或第三人權利受損時，應負一切法律責任。\n\n第十二條、遊戲歷程之保存與查詢\n\n乙方應保存甲方之個人遊戲歷程紀錄，且保存期間為三十日，以供甲方查詢。\n甲方得以書面、網路，或親至乙方之服務中心申請調閱甲方之個人遊戲歷程，且須提出與身分證明文件相符之個人資料以供查驗，查詢費用如下，由甲方負擔：新台幣二百元。\n乙方接獲甲方之查詢申請，應提供第一項所列之甲方個人遊戲歷程，並於七日內以儲存媒介或書面、電子郵件方式提供資料。\n\n第十三條、個人資料\n\n關於個人資料之保護，依相關法律規定處理。\n\n第十四條、電磁紀錄\n\n本遊戲之所有電磁紀錄均屬乙方所有，乙方並應維持甲方相關電磁紀錄之完整。\n甲方對於前項電磁紀錄有使用支配之權利。但不包括本遊戲服務範圍外之移轉、收益行為。\n\n\n第十五條、連線品質\n\n乙方為維護本遊戲服務相關系統及軟硬體設備而預先規劃暫停本遊戲服務之全部或一部時，應於七日前於官網首頁、遊戲登入頁面或購買頁面公告。但因臨時性、急迫性或不可歸責於乙方之事由者，不在此限。\n因可歸責乙方事由，致甲方不能連線使用本遊戲服務時，乙方應立即更正或修復。\n對於甲方於無法使用期間遭扣除遊戲費用或遊戲內商品，乙方應返還遊戲費用或商品，無法返還時則應提供其他合理之補償。\n\n第十六條、企業經營者及消費者責任\n\n乙方應依本契約之規定負有於提供本服務時，維護其自身電腦系統，符合當時科技或專業水準可合理期待之安全性。\n電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時，乙方應於採取合理之措施後儘速予以回復。\n乙方違反前二項規定或因遊戲程式漏洞致生甲方損害時，應依甲方受損害情形，負損害賠償責任。但乙方能證明其無過失者，得減輕其賠償責任。\n乙方電腦系統發生第二項所稱情況時，於完成修復並正常運作之前，乙方不得向甲方收取費用。\n甲方因共用帳號、委託他人付費購買點數衍生與第三人間之糾紛，乙方得不予協助處理。\n\n第十七條、遊戲管理規則\n\n為規範遊戲進行之方式，乙方應訂立合理公平之遊戲管理規則，甲方應遵守乙方公告之遊戲管理規則。\n遊戲管理規則之變更應依第二十條之程序為之。\n遊戲管理規則有下列情形之一者，其規定無效：\n一、牴觸本契約之規定。\n二、剝奪或限制甲方之契約上權利。但乙方依第十八條之規定處理者，不在此限。\n\n第十八條、違反遊戲管理規則之處理\n\n除本契約另有規定外，有事實足證甲方於本遊戲服務中違反遊戲管理規則時，乙方應於官網首頁、遊戲登入頁面或購買頁面公告，並依甲方登錄之通訊資料通知甲方。\n甲方第一次違反遊戲管理規則，乙方應通知甲方於一定期間內改善。\n經乙方通知改善而未改善者，乙方得依遊戲管理規則，按其情節輕重限制甲方之遊戲使用權利。\n如甲方因同一事由再次違反遊戲管理規則時，乙方得立即依遊戲管理規則限制甲方進行遊戲之權利。\n乙方依遊戲管理規則限制甲方進行遊戲之權利，每次不得超過七日。\n\n第十九條、申訴權利\n\n甲方不滿意乙方提供之連線品質、遊戲管理、費用計費、其他相關之服務品質，或對乙方依遊戲管理規則之處置不服時，得於收到通知之翌日起七日內至乙方之服務中心或以電子郵件或書面提出申訴，乙方應於接獲申訴後，於十五日內回覆處理之結果。\n乙方應於官網或遊戲管理規則中明定服務專線、電子郵件等相關聯絡資訊與二十四小時申訴管道。\n甲方反映第三人利用外掛程式或其他影響遊戲公平性之申訴，依第一項規定辦理。\n\n第二十條、契約之變更\n\n乙方修改本契約時，應於官網首頁、遊戲登入頁面或購買頁面公告之，或依甲方登錄之通訊資料通知甲方。\n乙方未依前項進行公告及通知者，其契約之變更無效。\n甲方於第一項通知到達後十五日內：\n一、甲方未為反對之表示者，乙方依契約變更後之內容繼續提供本遊戲服務。\n二、甲方為反對之表示者，依甲方終止契約方式處理。\n\n第二十一條、契約之終止及退費\n\n當點數儲值入本服務經兌換/消耗後，無法取消、更改、退費或轉入其他遊戲中。\n甲方得隨時通知乙方終止本契約。\n乙方得與甲方約定，若甲方逾一年期間未登入使用本遊戲服務，乙方得通知甲方於十五日內登入，如甲方屆期仍未登入使用，則乙方得終止本契約。\n甲方有下列重大情事之一者，乙方依甲方登錄之通訊資料通知甲方後，得立即終止本契約：\n一、利用任何系統或工具對乙方電腦系統之惡意攻擊或破壞。\n二、以利用外掛程式、病毒程式、遊戲程式漏洞或其他違反遊戲常態設定或公平合理之方式進行遊戲。\n三、以冒名、詐騙或其他虛偽不正等方式付費購買點數或遊戲內商品。\n四、因同一事由違反遊戲管理規則達三次（含）以上，經依第十九條第二項通知改善而未改善者。\n五、經司法機關查獲從事任何不法之行為。\n乙方對前項事實認定產生錯誤或無法舉證時，乙方應對甲方之損害負賠償責任。\n契約終止時，乙方於扣除30%通路成本與10%人事成本後(若匯款需扣除30元手續費)，於三十日內以現金、信用卡、匯票或掛號寄發支票方式退還甲方未使用之付費購買之點數或遊戲費用，或依雙方同意之方式處理前述點數或費用。\n遊戲中貨幣取得來源區分為二種，使用時消耗先後順序排列如下：\n一、有價點數(線上購點/點數卡儲值)\n二、免費點數(遊戲內活動取得、購點時額外贈送、其他活動兌換等)\n如甲方於遊戲內進行購買服務、道具等消耗動作時，會依照此順序進行點數消耗。\n(免費點數將不列入退費計算)\n\n第二十二條、停止營運\n\n因乙方停止本遊戲服務之營運而終止契約者，應於終止前三十日公告於官網首頁、遊戲登錄頁面或購買頁面，並依甲方登錄之通訊資料通知甲方。\n乙方未依前項期間公告並通知，除應退還甲方未使用之付費購買點數或遊戲費用且不得扣除必要成本外，並應提供其他合理之補償。\n\n第二十三條、送達\n\n有關本契約所有事項之通知，甲方同意乙方依甲方登錄之通訊資料為送達。\n前項登錄通訊資料若有變更，甲方應即通知乙方。乙方應依變更後之通訊資料為送達。\n乙方依甲方登錄之通訊資料所為之通知發出後，以書面通知到達甲方，或電子郵件進入甲方之電子郵件伺服器中，推定為已送達。\n因甲方之故意或過失致乙方無法為送達者，乙方對甲方因無法送達所致之損害不負賠償責任。\n\n第二十四條、準據法\n\n本契約以中華民國法律為準據法。\n\n第二十五條、管轄法院\n\n因本契約而生之事件，雙方合意以臺灣臺北地方法院為第一審管轄法院。\n前項約定不得排除消費者保護法第四十七條及民事訴訟法第二十八條第二項、第四百三十六條之九規定之適用。\n",
  },

  privacy: {
    title: "艾瑞爾網路股份有限公司「個人資料暨隱私權保護政策」",
    content:
      "親愛的用戶您好：\n艾瑞爾網路股份有限公司(以下簡稱「艾瑞爾」)十分重視您個人資料之安全及隱私權之保護，為保障您的權利，特制定本個人資料暨隱私權保護政策(下簡稱「本政策」)，並依個人資料保護法之規定於蒐集前告知。\n\n請於註冊登入艾瑞爾所提供之相關遊戲及服務前，先行審閱並同意艾瑞爾之用戶協議，並於本網站詳閱且同意本政策。提醒您，若您註冊登入艾瑞爾提供之服務，根據用戶協議(或稱使用者條款)之規定，視同您已審閱、瞭解並同意本政策。本政策將長期公告於本網站，為配合相關法規，本政策隨時可能修訂，請您定期瀏覽本網站及相關通知或公告，若有疑問，歡迎自各遊戲客服管道詢問。\n\n特此提醒您，若您未滿20歲，請由法定代理人代您同意本政策及用戶協議。若您未滿7歲，請由您的父母、監護人、照顧人或您的法定代理人代替您審閱並同意本政策及用戶協議，並由他們代為註冊登入。再次提醒您，若您完成註冊登入，視同已對本政策及用戶協議完全理解、知悉並同意，敬請慎重。\n\n\n第一條 適用範圍\n當您使用艾瑞爾所提供之服務時，有關您個人資料之蒐集、處理、利用等即有本政策之適用。但不適用於經艾瑞爾網站或服務而連結至第三方經營之網站或網頁等，有關第三方之服務，適用各該第三方網站的隱私權政策，艾瑞爾不負任何連帶責任。\n\n第二條 蒐集之目的\n為提供您使用艾瑞爾之服務，我們將於必要範圍內取得您的資訊。\n根據艾瑞爾所提供不同服務目的，可能蒐集之資料，例示如下。\n一、進行遊戲之資料：\n為供您登入及進行遊戲，艾瑞爾將蒐集您提供之特定訊息，包括姓名、暱稱、身份證字號、電話、電子信箱、居住地區、語言設定等相關必要資料。\n二、 遊戲運作之資料：\n為維持遊戲運作和服務品質，亦可能蒐集您的電腦硬體、軟件和行動電話裝置的資料、行動裝置及連線環境相關之資訊，包括您的IP位置、產品型號、作業系統、網路服務提供者、瀏覽器類型、登入時間、使用時間、網站地址/紀錄等軌跡資料，及遊戲內容、購買紀錄、獎品紀錄、與玩家間之關係等。\n三、 線上交易之資料：\n為確保完成付款、儲值等消費服務，於使用線上交易服務時，將會依照你提出的線上交易形態，蒐集您所填寫的訂單相關資料。\n四、 線上活動之資料：\n為確保您參加活動之權益或為網路調查之進行，若您已為會員關於您個人資料，將直接由會員資料庫提供進行核對。若您是各服務之用戶或體驗用戶等，則當該項活動仍需補充相關資料時，請您詳細登錄所需之資料。 \n五、 Cookies：\nCookies可以在您重回網站時記住您的偏好及使用習慣，且自動調整顯示的內容以改善您的用戶體驗。艾瑞爾可能使用Cookies蒐集之資料包含：網站管理、活動紀錄、網站使用動態等。若您不願接受Cookies的寫入，可以透過您的瀏覽器設定變更Cookies設置或設定隱私權等級為高，不過請您注意，關閉Cookies將可能導致網站部分功能無法正常執行。\n六、 瀏覽網頁之資料：\n為提升艾瑞爾的服務品質，當您於艾瑞爾網站內或其附屬網站中瀏覽或查詢時，艾瑞爾伺服器將自動紀錄您使用連線之IP位置、時間及瀏覽等相關記錄。這些資料僅供作流量統計分析及網路服務優化之用，僅為總量上的分析，不會和特定個人相聯繫。\n七、 其他：\n除了您直接提供的個人資料之外，您也可能在艾瑞爾合作廠商處主動提供個人資料，並在您同意或為履行契約目的前提下，將您的個人資料提供給艾瑞爾。若您於艾瑞爾之服務活動時連結第三方之服務，艾瑞爾可能蒐集您於該第三方服務之相關資訊。這些資料只會在您同意或為履行契約的服務範圍內利用及處理，不會用於其他用途。\n\n第三條 蒐集資料之類別\n可能蒐集之個人資料類別：(參見法務部-個人資料保護法之特定目的及個人資料之類別)\n一、 辨識個人用(C001) 例如：姓名、行動電話、帳號、相片、電子郵件等。\n二、 辨識財務用(C002) 例如：銀行帳戶之號碼與姓名、信用卡金融卡號碼等。\n三、 政府資料中之辨識者(C003) 例如：身分證統一編號等。\n四、 個人描述(C011) 例如：年齡、性別、出生年月日等。\n五、 書面文件之檢索(C131) 例如：書面文件之索引或代號等。\n六、 未分類之資料(C132) 例如：檔案、報告或電子郵件等。\n\n第四條 利用之期間、地區、對象及方式\n一、 期間：用戶資料將於艾瑞爾服務之營運期間內使用，至您要求停止使用或該服務終止之日。參加活動者個人資料之使用，自您提交資料參與活動之時至活動結束後3個月。\n二、 地區：台灣地區及提供艾瑞爾與其所附屬網站服務之地區。在本政策所載目的範圍內，您的個人資料可能被使用或利用在台灣及艾瑞爾關係企業或艾瑞爾所附屬網站之服務地區或其所在地之國家。\n三、 對象：僅供您同意之服務目的及艾瑞爾內部相關連之範圍內使用或利用，不會任意將您提供的個人資料轉供其他第三人或移作其他目的使用。惟為履行契約目的、完成履行契約之義務，將提供相關資料予合作廠商。\n四、 利用方式： \n1. 用於履行艾瑞爾所提供之服務\n艾瑞爾可能使用您所提供之資訊以提供、維護、完善艾瑞爾研發、經營或管理之應用程式、相關網站等，並用於防止非法活動、違反用戶協議之行為等。如您選擇使用線上交易服務，將會依照你提出的線上交易形態，蒐集您所填寫的訂單相關資料，以確保您完成付款、儲值或物流等消費服務。\n2. 用於解決用戶疑難或消費爭議\n若您向艾瑞爾詢問您使用相關應用程式或網頁等服務時發生之問題，艾瑞爾可能使用您提供之資料用於解決該等問題。若您與艾瑞爾有相關爭議時，艾瑞爾可能使用您的個人資料用以證明或溝通相關情況。\n3. 線上活動及調查\n您若因參加艾瑞爾舉辦之線上活動或網路調查，而留下的個人資料，該資料僅供該次活動或調查使用，該資料並於活動或調查結束後銷毀。\n4. 統計與分析\n您在執行遊戲服務時，艾瑞爾將會自動蒐集您使用設備之相關資訊，並作為您個人遊戲習慣及消費行為分析之用，以改善服務、設計會員活動、遊戲內容優化、行銷活動、研發新產品與服務等之依據。並且，艾瑞爾針對您申請遊戲帳號時所取得的資料，以及站內瀏覽時伺服器所產生的紀錄，將不定期進行總體會員行為分析與統計，惟此處之分析不會針對個人行為進行。\n\n第五條 您得行使之權利及方式\n一、 依個人資料保護法，您得向艾瑞爾請求行使以下權利：\n(1)查詢或請求閱覽；(2)請求製給複製本；(3)請求補充或更正；\n(4)請求停止蒐集、處理或利用；(5)請求刪除。\n二、 若您不符合艾瑞爾申請程序或法令另有規定時，以上權利將會受到限制。\n三、 申請程序：欲行使本條第一項之權利，需完成以下程序。\n1. 應填妥申請文件\n2. 當事人應向艾瑞爾提出可茲確認之身分證明文件\n3. 艾瑞爾得就您提出之請求酌收必要成本費用\n4. 若委託他人代為申請者，應出具委任書，且提供本人及代理人之身分證明文件\n\n第六條 您得自由提供個人資料時，若不提供，將對您權益所生之影響\n若您無法提供完整且符合真實之個人資料，將對艾瑞爾在下列情況產生影響：提供服務、和您之聯繫、完成交易、身份驗證、處理消費/交易/客訴等問題或其他業務。\n建議您應提供完整的個人資料且隨時更新。若因您未提供完整且符合真實之個人資料造成對您及第三人發生損害時，您應負擔完全法律責任，如造成艾瑞爾的損失，應對艾瑞爾負損害賠償責任。\n\n第七條 個人資料之維護\n關於您的個人資料，艾瑞爾將盡力以適當、合理之技術及措施維護您的資料安全，並依相關法令辦理安全維護事項，防止您的個人資料被竊取、竄改、毀損、滅失或洩漏，除了下列情況外，在未得到您的同意以前，絕不對外揭露您的個人資料。\n1. 基於法律之規定或有利於您的權益。\n2. 為履行契約之目的或義務。\n3. 受司法機關或其他有權機關之要求。\n4. 為免除您生命、身體、自由或財產上之危險。\n5. 在緊急情況下為維護其他用戶或第三人之人身安全。\n\n第八條 本政策之修改\n艾瑞爾有權自行修訂隱私權政策，相關修正規定將公告於本網站，為保障您的權益，請您定期瀏覽本網站及相關通知或公告。本政策修改或變更後若您繼續使用艾瑞爾所提供之服務，表示您已審閱、瞭解並同意接受隱私權政策修改或變更後之內容。\n若您不同意本隱私權政策，請您立即停止使用艾瑞爾網站與其所附屬之相關服務。\n\n第九條 看法與建議\n您如果對於艾瑞爾隱私權政策或與個人資料有關之事項有任何意見或疑問，歡迎自各遊戲客服管道來信詢問。\n",
  },

  news: [
    {
        id: "0",
        preview: "歡慶週年撒福利 多重好禮與選美大賽登場",
        title: "歡慶週年撒福利 多重好禮與選美大賽登場",
        time: "2022-07-20",
        first_paragraph:
          "\t古風模擬經營手機遊戲《歡樂大東家》慶祝遊戲一週年紀念，於今（20）日正式展開週年慶系列活動。為了酬謝東家們過去一年，攜手旗下門客共創繁華經商榮景的努力，官方推出七日簽到、聚寶盆、商海通卷、選美大賽等福利回饋活動，豪撒禮包及各式精美禮品，要與老東家們一同回顧經商的酸甜苦辣，也邀請新東家們齊聚遊戲盛典，共襄盛舉。",
        contents: [
          {
            id: "1",
            img: require("./images/news-1.jpg"),
            imgMsg:'《歡樂大東家》歡慶一週年，邀東家們共襄盛舉',
            paragraph:
              "\t●週年慶預熱活動開跑，選美大賽隆重登場！",
          },
          {
            id: "2",
            img: "",
            paragraph:
              "\t隨著週年慶活動開跑，東家們跟著角色再次「回到古代，做點買賣」，遊戲中也有不少女東家深諳經商之道，玩起談判收購照樣手到擒來，巾幗不讓鬚眉，為此官方特別要為女東家們謀福利，不惜砸重本祭出豐厚禮品，廣邀女東家們參與選美大賽「錦繡東家錄」，共赴週年慶典角逐花魁拿好禮！",
          },
          {
            id: "3",
            img: require("./images/news-2.jpg"),
            imgMsg:'選美大賽「錦繡東家錄」即日起開放報名',

            paragraph:
              "\t活動報名時間從7月20日至7月24日，限定開放現實中的女東家們登入遊戲上傳「自拍照」報名參加，只要報名成功就送粉色爆擊*1、粉黛登場*1、龍延香*9、商客一覽*5、資質經驗手抄*5的遊戲禮包。",
          },
          {
            id: "4",
            img: "",
            paragraph:
              "\t7月26日至7月31日，則會於遊戲內提供全服玩家進行投票，票選出前11名最美大東家，獲得官方準備的精美好禮及豐厚遊戲禮包，想艷壓群芳拿好禮的女東家們還不快手刀報名起來，這樣的好康絕對不容錯過！活動共分4階段逐步展開錦繡東家錄選美大賽活動獎勵",
          },
          {
            id: "5",
            img: require("./images/news-3.jpg"),
            imgMsg:'活動共分4階段逐步展開',

            paragraph:
              "錦繡東家錄選美大賽活動獎勵",
          },
          {
            id: "6",
            img: "",
            paragraph:
              "第1名：LV-NEVERFULL MM、絕代仙姿、春華競芳",
          },
          {
            id: "7",
            img: "",
            paragraph:
              "第2名：Dyson禮盒（吹風機+造型器）、國色天香、春華競芳",
          },
          {
            id: "8",
            img: "",
            paragraph:
              "第3名：Clé de Peau Beauté精質逆齡經典組、國色天香、春華競芳",
          },
          {
            id: "9",
            img: "",
            paragraph:
              "第4名：SK-II青春活膚緊緻雙重組、旖旎佳人、春華競芳",
          },
          {
            id: "10",
            img: "",
            paragraph:
              "第5名：Chanel N°5、旖旎佳人、春華競芳",
          },
          {
            id: "11",
            img: "",
            paragraph:
              "第6-11名：MyCard點數卡1000元、天生麗質、春華競芳",
          },
          {
            id: "12",
            img: "",
            paragraph:
              "報名獎：粉色爆擊*1、粉黛登場*1、龍延香*9、商客一覽*5、資質經驗手抄*5",
          }, {
            id: "13",
            img: require("./images/news-4.jpg"),
            imgMsg:'活動獎勵豐厚，機會難得不容錯過！',

            paragraph:
              "\t●連續七天簽到就送「元小寶」喵助手皮膚",
          },{
            id: "14",
            img: "",
            paragraph:
              "\t為了讓東家們在週年慶期間玩得盡興，官方贈禮也豪不手軟，只要7月21日至7月31日登入簽到就送豪華遊戲虛寶，連續簽到七天還能收獲週年慶限定珍獸「元小寶」喵助手皮膚，啟動屬性可增加100點成長值及100點潛力值，為東家擴張商業版圖再添助力。",
          }, {
            id: "15",
            img: require("./images/news-5.jpg"),
            imgMsg:'週年慶線上預熱首波活動陸續展開',

            paragraph:
              "\t●善用聚寶盆，一鍵回購離線期間資源",
          }, {
            id: "16",
            img: "",
            paragraph:
              "\t官方除了為持續在線玩家送獎勵外，也推出期間限定的「聚寶盆」活動，為回流玩家謀福利，離線的玩家可於7月21日至7月23日期間，消耗聚寶道具開啟聚寶盆，累積聚寶倍數就有機會獲得對應倍數的豐厚家財，快速回購離線期間流失的鉅額資產，讓玩家重回大東家也不會落於人後。",
          }, {
            id: "16",
            img: "",
            paragraph:
              "\t●「商海通卷」續寫東家輝煌經商史",
          }, {
            id: "17",
            img: "",
            paragraph:
              "\t另外，7月21日至7月27日，東家們還可透過「商海通卷」查看過往經商數據，從招攬門客數、歷史最高賺速、珍獸收獲總數到育兒總數都將完整呈現，隨卷展開可回顧初入遊戲白手起家到如今坐擁萬貫家財，成為商界巨擘的點點滴滴，看自己如何在商界呼風喚雨，續寫燦爛的輝煌事蹟，卷末還會贈送虛寶獎勵慰勞東家過去的努力。              ",
          },
          {
            id: "15",
            img: require("./images/news-6.jpg"),
            imgMsg:'週年慶好禮「獎」不完，手刀加入領福利！',
            paragraph:
              "\t除了以上的精彩活動外，後續官方還將陸續推出更多週年慶系列活動及豐厚福利，勢必要讓玩家們滿載而歸，不想錯過的玩家可持續關注《歡樂大東家》官方粉絲團，接收活動第一手消息！繼續重回古代續寫自己的輝煌商績。",
          },{
            id: "12",
            img: "",
            paragraph:
            `IOS版下載連結：<a href="https://happyboss.onelink.me/vJom/news" target="_blank">https://happyboss.onelink.me/vJom/news</a>\n Android版下載連結：<a href="https://www.facebook.com/happybigboss" target="_blank">https://happyboss.onelink.me/vJom/news</a>\n官方粉絲團：<a href="https://www.facebook.com/happybigboss" target="_blank">https://www.facebook.com/happybigboss</a>\n官方網站：<a href="http://www.iyagames.com/ddj/#/" target="_blank">http://www.iyagames.com/ddj/#/</a>`,
          }

        ],
        year: "2022",
        date: "07-20",
      },
    {
      id: "1",
      preview: "歡樂大東家介紹",
      title: "從經營客棧到商會大東家，在古代經商的體驗是什麽樣的？",
      time: "2021-07-05",
      first_paragraph:
        "\t作為一個擁有數千年歷史的文明，我國經商的歷史可以說是非常悠久了，在各大影視劇中，也有許多以經商為題材的創作。但是仔細一想，古代的商人具體是如何運作生意來往的呢？相信許多人也是一頭霧水，所以，最近有一款叫《歡樂大東家》的遊戲就把我們帶回到了古代，從一名商人的角度出發，看看古代的經商之路，到底是如何發展的。",
      contents: [
        {
          id: "1",
          img: require("./images/news1.1.png"),
          paragraph:
            "\t遊戲整體的風格是比較偏向於詼諧的，故事一開始，你作為一個主人公，將會在不慎落水後被撈起來，還沒等你反應過來，便被拉著去繼承父親留給你的產業，一間老字號客棧。好吧，在接受了這種無厘頭的天降產業設定後，那就開始努力賺錢吧！",
        },
        {
          id: "2",
          img: "",
          paragraph:
            "\t不過經商之路可沒有電視劇中那麽簡單，在穩定運作好客棧以後，你將要逐漸拓展更多的產業，畢竟我們的目標是賺更多的錢，所以產業多樣化是必不可少的一步。",
        },
        {
          id: "3",
          img: "",
          paragraph:
            "\t當你經過一番努力，終於盤下布莊以後，貨物運輸路線又成了一個問題。在古代可沒有快遞這種東西，但是聽說有個神秘的曹老板開了運送貨物的順風驛站，找他合作也許是一個不錯的選擇。在擁有了自己的專屬驛站服務之後，你的經商之路也終於算是邁出了第一步。",
        },
        {
          id: "4",
          img: "",
          paragraph: "\t於是，遊戲的主線故事就在這樣的前提下展開了。",
        },
        {
          id: "5",
          img: require("./images/news1.2.png"),
          paragraph:
            "\t也許很多人會好奇，古代商人們的日常生活究竟是什麽樣的呢？《歡樂大東家》就這個問題進行了深入的研究，打造出了能讓玩家身臨其境的一套玩法。其實經商，說白了還是利益至上。那麽商人之間的明爭暗鬥，最直接的方式就是看誰更有錢！",
        },
        {
          id: "6",
          img: require("./images/news1.3.png"),
          paragraph:
            "\t在推進主線劇情時，玩家們會遇到許多等待收購的產業與各色商人，這些商人都是在商道摸爬滾打多年的老油子，想要跟他們談判成功，可要花費不少精力。因為收購的產業都在不同的城市，如果你想要盤下一間食府，那麽食府裏的各色雜役，主廚和掌櫃，都需要你去進行收購談判，如果你的產業做得夠大，那麽談判時需要付出的銀幣也會減少，而如果你的實力不夠強，那麽談判時或許會被嫌棄，付出更多的代價。",
        },
        {
          id: "7",
          img: require("./images/news1.4.png"),
          paragraph:
            "\t當你旗下的產業越來越多以後，你會明顯感覺到分身乏術，那麽這時候，門客就可以幫你解決很多瑣碎的事情與產業管理了。在經商的途中，或者外出遊歷，都有可能結識到善於管理的門客，與他們結識之後，就可以將他們派往各大產業進行管理，而且還可以讓他們在商業談判的時候出一份力。",
        },
        {
          id: "8",
          img: require("./images/news1.5.png"),
          paragraph:
            "\t除此以外，當你的產業擴大之後，還可以與各國的商人進行通商，換取珍稀貨物。遊戲中還設置了不少有趣的玩法，例如讓門客進行學習的賬房玩法；舉辦宴會，宴請八方的宴會玩法；參與打獵，遊歷山林的獵場玩法......等等這些都是將經商和不同元素玩法相結合起來，玩法雖多但不繁瑣，這樣的一輪日常做下來只需點手指完成，卻仿佛真的體驗到了古代一方東家的日常生活。",
        },
        {
          id: "9",
          img: "",
          paragraph:
            "\t從以上都不難看出，《歡樂大東家》整個玩法都是偏輕度休閑的，遊戲當中並沒有設定太多的硬性目標，給人的感覺不肝，玩法相對來說還是較為輕松的。如果你是模擬經營遊戲與無厘頭風格的愛好者，那麽不妨試試這款《歡樂大東家》，相信這款遊戲一定能給你帶來新的模擬經營體驗。",
        },
      ],
      year: "2021",
      date: "07-05",
    },
    {
      id: "2",
      preview: "闖關玩法介紹",
      title: "《歡樂大東家》闖關玩法介紹",
      time: "2021-07-05",
      first_paragraph:
        "\t當你從睡夢中醒來，卻發現自己穿越到了古代，變成了一名玩世不恭的公子哥，而擺在你面前的只有一個選擇，就是繼承家中的客棧產業，開啟自己的經商之路。這就是《歡樂大東家》中主線故事劇情的開端，那麽作為主人公的你，又將會如何經歷這個故事？",
      contents: [
        {
          id: "1",
          img: require("./images/news2.1.png"),
          paragraph:
            "\t在遊戲中，主線劇情是隨著闖關玩法的推進而解鎖的，隨著闖關玩法的解鎖，玩家們也會逐漸開始擴大自己的產業，走上成為一方大東家的道路。今天就給大家詳細介紹一下與闖關相關的玩法吧！",
        },
        {
          id: "2",
          img: require("./images/news2.2.png"),
          paragraph:
            "\t既然決定了要好好經商，你面臨的問題，就是如何將一家老字號客棧重新經營得當。在經過嘗試以及門客們的幫助下，客棧的生意越來越好了，而積攢下的銀兩也讓你有了盤下一家老布莊的想法，不過首先你得先去跟布莊背後的商會談判關於產業收購的事宜。",
        },
        {
          id: "3",
          img: require("./images/news2.3.png"),
          paragraph:
            "\t既然是收購談判，那麽就得由門客們去代替你充當說客了。在關卡中，會遇到許多需要進行打點與溝通的人物，派遣門客去與他們進行談判，而在談判的過程中，需要消耗銀兩，如果門客的財力夠高，那麽消耗的銀兩也會降低。",
        },
        {
          id: "4",
          img: "",
          paragraph:
            "\t每當談判完成，都會增加一定的名望，積累名望可以提升名望等級，給你帶來諸如銀兩儲存上限以及好友位上限的提升。",
        },
        {
          id: "5",
          img: require("./images/news2.4.png"),
          paragraph:
            "\t當談判目標完成以後，就可以對相關的產業進行收購了，收購完成的產業將會在主界面進行解鎖，然後就可以進行派遣門客入駐以及招募夥計等操作了。",
        },
        {
          id: "6",
          img: require("./images/news2.5.png"),
          paragraph:
            "\t以上就是《歡樂大東家》中關於闖關玩法的一些介紹了，相信在你的努力下，收購的產業一定會越來越多，成為全國聞名，富甲一方的大商人！",
        },
      ],
      year: "2021",
      date: "07-05",
    },
    {
      id: "3",
      preview: "門客玩法介紹",
      time: "2021-07-05",
      title: "《歡樂大東家》門客玩法介紹",
      first_paragraph:
        "\t想要成為富甲一方的商人，擁有一批能幹的門客是非常重要的，門客可以幫你打理，經營產業，同時也可以在收購談判中發揮重要的作用，那麽我們應該如何獲取一名門客，而門客又有哪些相關的玩法呢？",
      contents: [
        {
          id: "1",
          img: require("./images/news3.1.png"),
          paragraph:
            "\t在遊戲的初期，我們可以獲得兩位初始門客，小喬以及唐伯虎。而其他的門客則可以隨著遊戲玩法的推進而解鎖，或者通過一些特殊的渠道進行獲取。",
        },
        {
          id: "2",
          img: require("./images/news3.2.png"),
          paragraph:
            "\t如何查看一名門客的實力如何？只需要看看相關的資質即可，資質越高的門客，實力也會越高，同時每位門客都有屬於自己的專屬珍獸，如果獲取了專屬的珍獸，在培養以後也可以提高門客的實力。",
        },
        {
          id: "3",
          img: require("./images/news3.3.png"),
          paragraph:
            "\t在遊歷玩法中，我們可以結交到許多實用的門客，遊歷的時候經過偶遇地點時，有概率觸發提高相應門客的好感度，當好感度達到滿值，我們就可以與這名門客進行結交了。而且遊歷的時候也可以獲取到與門客相關的專屬珍獸，大家可千萬記得要及時進行遊歷噢！",
        },
        {
          id: "4",
          img: require("./images/news3.4.png"),
          paragraph:
            "\t當把門客派遣到產業上時，就會給產業進行銀兩產出上的增速，資質越高的門客，可以提升的倍數也越多。同時每個門客對應的產業相性也不盡相同，有的門客擅長客棧的經營，有的門客擅長驛站的經營，將門客派遣到相性相同的產業時，能夠提供的加成是最高的，所以需要大家妥善安排門客的入駐。",
        },
        {
          id: "5",
          img: require("./images/news3.5.png"),
          paragraph:
            "\t而在談判時，一名優秀的門客也可以為我們節省大量的銀兩支出，讓闖關旅途更加輕松，總的來說，門客是《歡樂大東家》中一個特別重要的助力因素，大家可以多多培養自己的門客。以上就是《歡樂大東家》中關於門客玩法的一些介紹了，希望能對大家有所幫助！",
        },
      ],
      year: "2021",
      date: "07-05",
    },
  ],

  announcement: [
    {
        id: "3",
        preview: "樓蘭秘寶概率公示！",
        time: "2022-05-05",
        title: "樓蘭秘寶概率公示！",
        first_paragraph: "親愛的各位大東家：\n應有關法則規定，《歡樂大東家》遊戲內隨機玩法及其概率公示如下：\n",
        contents: [
          {
            id: "1",
            img: '',
            subTitle: "1. 樓蘭秘寶-精絕寶圖每次抽取道具概率公示如下：",
            paragraph:
              `<table>
                <tr>
                    <td>序號</td>
                    <td>獎勵</td>
                    <td>概率</td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>資質卷軸*1</td>
                    <td>3.45%</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>貨殖列傳*1</td>
                    <td>3.43%</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>大錢袋*1</td>
                    <td>6.86%</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>資質經驗手抄*1</td>
                    <td>10.35%</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>商賈便覽*1</td>
                    <td>10.35%</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>客商一覽*1</td>
                    <td>15.53%</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>點絳令*1</td>
                    <td>13.80%</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>珍獸融合丹*1</td>
                    <td>13.80%</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>珍獸潛能丹*1</td>
                    <td>13.80%</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>十萬閱歷*1</td>
                    <td>8.63%</td>
                </tr>
              </table>`,
          },
          {
            id: "2",
            img: '',
            subTitle: "2. 樓蘭秘寶-天遒寶圖每次抽取道具概率公示如下：",
            paragraph:
              `<table>
                <tr>
                    <td>序號</td>
                    <td>獎勵</td>
                    <td>概率</td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>資質卷軸*1</td>
                    <td>5.46%</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>葡萄美酒*1</td>
                    <td>5.46%</td>
                </tr>
                <tr>
                    <td>3</td>
                    <td>大錢袋*1</td>
                    <td>8.20%</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>貨殖列傳*1</td>
                    <td>8.20%</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>資質經驗手抄*1</td>
                    <td>10.90%</td>
                </tr>
                <tr>
                    <td>6</td>
                    <td>商賈便覽*1</td>
                    <td>11.64%</td>
                </tr>
                <tr>
                    <td>7</td>
                    <td>活力丹*1</td>
                    <td>10.90%</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>珍獸融合丹*2</td>
                    <td>13.08%</td>
                </tr>
                <tr>
                    <td>9</td>
                    <td>珍獸潛能丹*2</td>
                    <td>13.08%</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>點絳令*2</td>
                    <td>13.08%</td>
                </tr>
              </table>`,
          },
          {
            id: "3",
            img: '',
            subTitle: "3. 樓蘭秘寶每次均在隨機格子中進行抽取",
            paragraph:
              `注：經過數萬次大數據演算，平均75次左右可點亮精絕寶圖所有分塊\n注：經過數萬次大數據演算，最多150次左右可點亮天遒寶圖所有分塊\n溫馨提示：文中所用“概率”均是在大樣本(大量用戶)下的統計數值，與單個玩家的少量測試數據之間可能會存在一定差異。`,
          },
        ],
        year: "2022",
        date: "05-05",
      },
    {
      id: "2",
      preview: "雙平臺預註冊正式啟動",
      time: "2021-07-12",
      title: "雙平臺預註冊正式啟動！",
      first_paragraph: "\t親愛的各位東家：\n\t《歡樂大東家》正式開放雙平臺預約啦，元小寶在此先給大家深鞠一躬表示感謝！\n\t我們已於7月12日（今日）正式開啟谷歌/Appstore的預約，有參與事前預約的東家們，游戲上綫后即可領取元寶、大錢袋、經驗手冊等豐厚遊戲道具獎勵！更有豐厚加碼獎品：Iphone手機、Switch游戲機、藍牙耳機、游戲内儲值券······豐厚豪禮，通過預約頁登記，關注FB官網粉絲團，積極轉發按讚即有機會獲得喔~~《歡樂大東家》期待您的到來！",
      contents: [
        {
          id: "1",
          img: '',
          subTitle: "",
          paragraph:
            '\t事前預約地址：<a href="http://www.iyagames.com/ddj-yy/" target="_blank">http://www.iyagames.com/ddj-yy/</a>\n\t《歡樂大東家》FB粉絲團：<a href="https://www.facebook.com/happybigboss" target="_blank">https://www.facebook.com/happybigboss</a>\n\tGoogle預註冊地址：<a href="http://pesc.pw/3jn33l" target="_blank">http://pesc.pw/3jn33l</a>\n\tApp store預約地址：<a href="http://pesc.pw/3juukt" target="_blank">http://pesc.pw/3juukt</a>',
        },
      ],
      year: "2021",
      date: "07-12",
    },
    {
      id: "1",
      preview: "歡樂大東家簡介",
      time: "2021-07-06",
      title: "《歡樂大東家》遊戲介紹",
      first_paragraph:
        "\t《歡樂大東家》是一款古代經商與模擬經營遊戲，精美的卡通畫面、詼諧幽默的無厘頭劇情，讓玩家重回古代，憑著過人的頭腦，建造經營屬於自己的一方產業。遊戲中設置了很多有趣的要素，例如種類繁多的各種產業，身懷絕活的門客，談判與收購系統等等，如果你喜歡無厘頭風格與模擬經營的話，那就快來嘗試一下吧！",
      contents: [
        {
          id: "1",
          img: "",
          subTitle: "【當甩手掌櫃，看上的產業全都收收收！】",
          paragraph:
            "\t天上掉下一間客棧？突然成為客棧掌櫃的你，要如何經營這家老字號產業呢？別怕，各大門客來幫你忙！你只需要當好甩手掌櫃，日常收帳就好了。聽說洛陽有家劇院生意不錯？馬上啟程去談判，看上的產業全部收入囊中！聽說有家驛站跑腿快捷又方便？那必須收購，就改名為“順風驛站”吧！",
        },
        {
          id: "2",
          img: require("./images/announcement1.1.png"),
          subTitle: "【得神秘門客，擼貓也能漲實力？】",
          paragraph:
            "\t想要賺更多的錢，那麽就得收購更多的產業，那麽在管理上需求的門客也就越多。在遊戲中，可以通過遊歷與各種玩法結識各種身懷絕技的門客，他們的身份都十分神秘，有的你根本想不到！而且這些門客提升實力的方法也是千奇百怪，除了可以在賬房裏學習提升，有的門客甚至可以靠珍獸閣擼貓使自己變強，可以說是十分無厘頭了。",
        },
        {
          id: "3",
          img: require("./images/announcement1.2.png"),
          subTitle: "【生意遍全球，商戰爭霸我為王！】",
          paragraph:
            "\t產業越做越大，竟然連外國商人都慕名而來，天竺、羅馬與大食等國的商人都想與你展開通商合作，真正的把生意拓展到全球範圍！而你的橫空出世也引來了不少人敵意的目光，那麽就到商戰爭霸較量一番吧，看看誰的硬實力足夠強！",
        },
        {
          id: "4",
          img: require("./images/announcement1.3.png"),
          subTitle: "【打造大財團，提升家族影響力！】",
          paragraph:
            "\t強強聯合一直是不變的真理，你可以與其他誌同道合的小夥伴一起組建家族，共同打造強大的家族財團。在家族中，可以進行專屬的家族貿易，當你的家族影響力越來越大，相信在經商路上，你必將加冕為王！",
        },
      ],
      year: "2021",
      date: "07-06",
    }
  ],

  activity: [ {
    id: "0",
    preview: "「錦繡東家錄」暨女神東家選美大賽活動須知",
    title: "「錦繡東家錄」暨女神東家選美大賽活動須知",
    time: "2022-07-20",
    first_paragraph:
      "",
    contents: [
      {
        id: "1",
        img: require("./images/news-7.jpg"),
        paragraph:
          "",
      },
      {
        id: "2",
        subTitle:"一、參賽須知",
        paragraph:
          `1、請參賽報名玩家（以下簡稱：您）依照活動規則的要求提供資料，提供資料不完整或提供非真實資訊，您的報名資格將會遭到取消。\n2、參賽年齡：18歲及以上。\n3、參賽性別：限身分證件登記之女性\n4、活動地區：香港、澳門、台灣、新加坡、馬來西亞地區\n5、您清楚並同意：不發表或做出任何涉及歧視性別、種族、宗教、政治等極端言論和行為，如經發現，活動主辦單位有權隨時取消或剝奪您的參賽資格或獲獎資格。\n6、您清楚並同意：參加網路比賽，勢必會將您提交的個人照片置於網路空間以進行評分，您保證擁有該照片之著作權，且同意於活動時間內免費將該照片之著作財產權及您的肖像權授權予活動主辦單位於Facebook官方粉絲團及遊戲官網利用（前揭利用權均為不限地區、期間、次數及方式，均包含著作權法第22條至第29條所定全部著作財產權之著作利用方式）。\n7、您清楚並同意：參加網路比賽，我們會收集您以下的個人資訊：遊戲 ID、遊戲內暱稱、遊戲頭像、您提交的個人照片。對於最終獲選的玩家，活動主辦單位會另外個別獲得您的同意，收集您的郵寄資訊以用於寄送實體獎品；對於未獲選的玩家，活動主辦單位將不會要求您提供郵寄資訊。以上全部個人資訊，活動主辦單位將在活動結束後【30】日內進行刪除，不會進行任何其他商業使用。如在活動期間，您對於個人資訊保護政策有建議或意見，可點擊【隱私協議】查看我們的隱私協議並與活動主辦單位聯絡。\n8、如您參加本活動，即同意接受本活動辦法與注意事項(含其更新修正內容)，獲獎名單依遊戲內、遊戲官網及Facebook官方粉絲團公佈為准；如有違反，活動主辦單位得取消您的參賽資格或得獎資格，不得異議，並對於任何破壞本活動之行為得依法處理。\n9、如果任何人發現本次活動的參賽作品有侵權的嫌疑，請即時與我們進行聯繫並提交相關證據，一經查實，我們將儘快將相關作品下架並取消相應參賽資格，且因侵權導致的賠償責任將由侵權人自行承擔。\n10、您保證所有填寫或提出之資料均為真實且正確，且未冒用或盜用任何第三人之資料或智慧財產權。若因您的資料填寫不完整或不正確，導致獲獎時無法通知、逾期及資料缺漏者，視同放棄獲獎資格，活動主辦單位將不另行通知或補寄獎品。如有不實或不正確之情事，活動主辦單位得取消您的參賽資格及獲獎資格；如有致損害於活動主辦單位或其他任何第三人權益，您應自行負擔一切法律責任。\n11、您如因參加本活動或因活動獎項而遭受任何損失，活動主辦單位不負任何責任。一旦獲獎者領取獎品後，若有遺失或被竊，活動主辦單位不發給任何證明或補償。\n12、活動主辦單位有權檢視本活動參加者之參加行為及中獎情形是否涉嫌不法或有違常理之異常狀況，包括但不限於下列情況：人為操作蓄意偽造、詐欺或以任何其他不正當的方式意圖以進行不實或虛偽活動參與行為、或登錄資料不實或不正確或盜用任何第三人之資料，或有違反活動規範之行為。活動參加者因上述情形所獲得之活動資格及獎品，活動主辦單位保有變更、終止其參加活動資格、取消中獎資格或暫停活動之權利，並就因此產生之損害，得向參加者請求賠償。\n13、參加者同意所有參加者所留存或產生之任何參與活動之資料及紀錄，均以活動主辦單位之電腦系統與時間紀錄為主。如有任何因電腦、網路、電話、技術或不可歸責於活動主辦單位之事由，而使系統誤送活動訊息或獲獎通知，或是而使參加者所寄出或登錄之資料有遲延、錯誤、無法辨識或毀損之情況，活動主辦單位不負任何法律責任，參加者、獲獎者亦不得因此異議。\n14、本活動若有未盡事宜，活動主辦單位有隨時修改、變更、暫停及解釋活動內容之權利，修改後之訊息將於遊戲內、遊戲官網或Facebook官方粉絲團上公佈，不另行通知。\n`,
      }, {
        id: "1",
        subTitle:"二、活動規則",
        paragraph:
          "<span style='font-weight: 700;'>·活動說明</span>",
      }, {
        id: "1",
        paragraph:
          "本次活動將通過玩家主動上傳自拍照，全民投票的方式來選出「最美東家」，活動投票結束後將根據每位元東家的投票數排序來評選出大家心目中最受歡迎的東家，並獲得大賽獎勵。",
      },
      {
        id: "1",
        img: require("./images/news-3.jpg"),
        paragraph:
          "",
      }, {
        id: "1",
        paragraph:
          "<span style='font-weight: 700;'>·活動時間</span>\n活動時間：7月20日10:00——8月5日23:00，共分為4個階段。\n報名階段：7月20日10:00——7月24日23:00\n1、活動須為本人報名參與。參加者本人限身分證件登記之女性，遊戲內主角身分等級達到6級或以上即可參與活動。\n2、報名需填寫報名資訊、上傳照片後，即可報名。\n報名資訊：女神暱稱、女神所在區服、參賽照片，女神常用聯絡方式（個人資訊會嚴格保密，僅用於發獎聯絡）\n參加活動照片要求：參加者應手持手機展示大東家主城遊戲畫面，且照片不得遮擋臉部。\n照片可在報名頁面中上傳圖片時進行裁剪，應選取清晰之近照。\n·報名資料提交後報名頁面將顯示「待審核」，此狀態下報名資料僅該參加者可見；當後臺審核通過時，顯示「審核已通過」即為報名成功。後臺審核通過後，照片即可在投票頁面展示。參加者可在報名頁面查看自己的報名記錄及審核情況。\n·已審核通過的參加者資訊將展示於投票頁面（僅限於照片、區服、昵稱），任何人均可查看，但此階段不可投票。\n·每位玩家最多擁有三次上傳機會，若均未通過審核，則無法繼續報名。\n·參加者提交之照片必須為參加者本人真實照片；如出現盜用，活動主辦單位有權將圖片下架及取消參與資格之權利；如涉及侵權問題，亦應由參加者自行承擔。",
      },{
        id: "1",
        paragraph:
          "<span style='font-weight: 700;'>·投票階段</span>\n①投票時間: 2022年7月26日10:00- -2022年7月31日23:00\n②每個帳號每天擁有3次投票機會。\n ③在任一選手展示區，選擇「投票」，即可消耗1次投票次數，為對應選手增加1點「熱度值」\n④本活動嚴禁使用不當手段獲取投票數，如發現刷票情形，將根據實際情況刪除對應票數或取消參賽資格。",
      },{
        id: "1",
        paragraph:
          "<span style='font-weight: 700;'>·領獎階段</span>\n①活動獲獎名單將在2022年8月1日——8月5日 23:00公佈\n②如出現熱度值相同情況，優先達到該熱度值的玩家獲勝。時間以主辦方的電腦統計時間為准。\n ※如遇特殊情況需延遲公佈，活動主辦單位將於Facebook官方粉絲團發佈公告說明。\n",
      },{
        id: "1",
        img: require("./images/news-4.jpg"),
        paragraph:
          "",
      },{
        id: "1",
        paragraph:
          "<span style='font-weight: 700;'>·獎勵發放</span>\n1、獎勵發放時間: 活動結束後30個工作天內\n2、8月6日開啟實物獎勵郵寄資訊收集，郵寄資訊及玩家身分驗證截止時間為8月13日23:59，逾期將視為自動放棄獎勵。時間以主辦方的電腦統計時間為准。\n3、遊戲道具獎勵預計活動結束後10個工作日內發放完畢，實物獎勵活動結束後30個工作日內寄出。\n4、獎品以實物為准，獲獎者不得要求將講品讓與他人或折換現金。如遇產品缺貨或不可抗力之事由導致獎品內容變更，活動主辦單位有權延後獎勵發放時間或變更獎品並改由等值商品取代之，得獎者不得要求折現或轉換其他商品。\n5、活動主辦單位不負獎品之任何維護、保固及瑕疵擔保責任。\n6、依台灣地區稅法規定，獎項金額若超過新台幣1,000元(含)以上，獎項所得將列入個人年度綜合所得稅申報，故得獎人需依規定填寫並繳交相關資料方可領獎；另獎項價值超過新台幣20,000元(含)以上，依法應扣繳10%稅金(非台灣地區境內居住者，不論實體獎項金額多寡，均需繳交20％稅金)。如獲獎者未能依法繳納應繳稅額或不同意提供資料或填寫相關檔，即視為自動放棄獲獎資格。\n7、發獎時活動主辦單位需驗證獲獎者身分，如發現參賽照片與本人不符，活動主辦單位將取消獲獎資格。",
      }
    ],
    year: "2022",
    date: "07-20",
  },],
};
